import React from 'react'
import { Field } from 'redux-form'
import i18n from '../../translations/i18n';

let SpecializedTranslationOptions = props => {
	let lng = props.lng;
	let showStandardPremium = (parseInt(props.totalWords, 10) > 10000) ? false : true
	let disabledStyle = showStandardPremium ? {} : {pointerEvents: "none"}
	return (
		<div>
		<div className="form-section">
			<div className="row">
				<div className="col-12 col-sm-4 form-input d-flex align-items-end">
					<div className="mx-auto">
						<div className="options-button standard-option" style={disabledStyle}>
							<Field
								name="translationLevel"
								id="basic-level"
								type="radio"
								component="input"
								value="basic"
								disabled={!showStandardPremium}
							/>
							<label htmlFor="basic-level" className="davron-label">
								<div className="options-main">
									<h5>{i18n.t('translation.basic', {lng})}</h5>
									<h4>{i18n.t('translation.basic_price', {lng})}</h4>
									<h6>{i18n.t('translation.basic_subtitle', {lng})}</h6>
									<h6 className="options-text text-center">{i18n.t('translation.basic_headline', {lng})}</h6>
								</div>
							</label>
						</div>
					</div>
				</div>
				<div className="col-12 col-sm-4 form-input d-flex align-items-end">
					<div className="mx-auto">
						<div className="options-button standard-option" style={disabledStyle}>
							<Field
								name="translationLevel"
								id="professional-level"
								type="radio"
								component="input"
								value="professional"
								disabled={!showStandardPremium}
							/>
							<label htmlFor="professional-level" className="davron-label">
								<div className="options-main">
									<h5>{i18n.t('translation.professional', {lng})}</h5>
									<h4>{i18n.t('translation.professional_price', {lng})}</h4>
									<h6>{i18n.t('translation.professional_subtitle', {lng})}</h6>
									<h6 className="options-text">{i18n.t('translation.professional_headline', {lng})}</h6>
								</div>
							</label>
						</div>
					</div>
				</div>
				<div className="col-12 col-sm-4 form-input d-flex align-items-end">
					<div className="mx-auto">
						<div className="premium-header">{i18n.t('translation.premium_header', {lng})}</div>
						<div className="options-button">
							<Field
								name="translationLevel"
								id="premium-level"
								type="radio"
								component="input"
								value="premium"
							/>
							<label htmlFor="premium-level" className="davron-label">
								<div className="options-main">
									<h5>{i18n.t('translation.premium', {lng})}</h5>
									<h4>{i18n.t('translation.premium_price', {lng})}</h4>
									<h6>{i18n.t('translation.premium_subtitle', {lng})}</h6>
									<h6 className="options-text">{i18n.t('translation.premium_headline', {lng})}</h6>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	)
}


export default SpecializedTranslationOptions


// WEBPACK FOOTER //
// ./src/components/translation/specialized_options.js